import { ModalBackdrop } from "./ModalBackdrop";
import { IcoClose } from "./icons";

export interface ConflictFieldDiff {
  label: string;
  yours: string;
  theirs: string;
}

interface ConflictDialogProps {
  title: string;
  actorName?: string | null;
  updatedAt?: string | null;
  fields: ConflictFieldDiff[];
  onKeepMine: () => void;
  onTakeTheirs: () => void;
  onClose: () => void;
  busy?: boolean;
}

const sinceNow = (iso: string): string => {
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const sec = Math.round(diff / 1000);
  if (sec < 60) return `${sec} сек. назад`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} мин. назад`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} ч. назад`;
  return new Date(iso).toLocaleString("ru");
};

const previewValue = (v: string): string => {
  const s = v.trim();
  if (!s) return "— пусто —";
  if (s.length > 140) return s.slice(0, 140) + "…";
  return s;
};

export function ConflictDialog({
  title,
  actorName,
  updatedAt,
  fields,
  onKeepMine,
  onTakeTheirs,
  onClose,
  busy,
}: ConflictDialogProps) {
  const who = actorName?.trim() ? actorName : "другой пользователь";
  const when = updatedAt ? sinceNow(updatedAt) : "только что";
  return (
    <ModalBackdrop onClose={onClose}>
      <div className="modal modal-narrow" onClick={(e) => e.stopPropagation()} role="dialog">
        <div className="modal-head">
          <h2>{title}</h2>
          <div className="spacer" />
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            disabled={busy}
            aria-label="Закрыть"
          >
            <IcoClose size={16} />
          </button>
        </div>

        <div className="modal-body conflict-body">
          <p className="conflict-lead">
            {who} изменил(а) эту запись {when}. Ваши правки не были сохранены.
            Выберите, какую версию оставить.
          </p>
          {fields.length > 0 && (
            <div className="conflict-fields">
              {fields.map((f) => (
                <div key={f.label} className="conflict-field">
                  <div className="conflict-field-label">{f.label}</div>
                  <div className="conflict-field-pair">
                    <div className="conflict-col conflict-col--mine">
                      <div className="conflict-col-title">Ваше</div>
                      <div className="conflict-col-value">{previewValue(f.yours)}</div>
                    </div>
                    <div className="conflict-col conflict-col--theirs">
                      <div className="conflict-col-title">На сервере</div>
                      <div className="conflict-col-value">{previewValue(f.theirs)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-foot">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onTakeTheirs}
            disabled={busy}
          >
            Взять серверную версию
          </button>
          <div className="spacer" />
          <button
            type="button"
            className="btn btn-primary"
            onClick={onKeepMine}
            disabled={busy}
          >
            Сохранить мои изменения
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}
